import React from 'react';
import { Phone, CheckCircle, Wrench, DollarSign } from 'lucide-react';
export function FreightBoxRepairPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-4222">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-4223">
        <div className="container mx-auto px-4" data-id="element-4224">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-4225">
            Truck Box Repair
          </h1>
          <p className="text-xl text-gray-100 text-center italic" data-id="element-4226">
            Serving Farmington Hills, Farmington, Novi, Livonia, Northville
            Since 1958
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-4227">
        <div className="max-w-4xl mx-auto" data-id="element-4228">
          {/* Image Gallery */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4229">
            <div className="grid md:grid-cols-3 gap-4 mb-4" data-id="element-4230">
              <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/P1010067-2.JPG200x200.jpg?opt=w3" alt="Box truck repair" className="w-full h-auto rounded-lg shadow-sm" data-id="element-4231" />
              <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/P1010070.JPG200x200.jpg?opt=w3" alt="Truck box repair work" className="w-full h-auto rounded-lg shadow-sm" data-id="element-4232" />
              <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/P1010069.JPG200x200.jpg?opt=w3" alt="Commercial truck repair" className="w-full h-auto rounded-lg shadow-sm" data-id="element-4233" />
            </div>
            <div className="grid md:grid-cols-3 gap-4" data-id="element-4234">
              <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/P1010076.JPG200x200.jpg?opt=w3" alt="Box truck body repair" className="w-full h-auto rounded-lg shadow-sm" data-id="element-4235" />
              <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/P1010085.JPG200x200.jpg?opt=w3" alt="Truck repair service" className="w-full h-auto rounded-lg shadow-sm" data-id="element-4236" />
              <img src="//drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2FP1010117.JPG&site=1986&w=200&h=181&user=1617&opt=w3" alt="Professional truck repair" className="w-full h-auto rounded-lg shadow-sm" data-id="element-4237" />
            </div>
          </div>

          {/* Professional Box Truck Repair */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4238">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-4239">
              Professional Box Truck Repair
            </h2>

            <p className="text-lg text-gray-700 mb-6" data-id="element-4240">
              We are the #1 choice in the tri-state area for box truck repairs.
              We understand your commercial box truck needs to be back in
              service as quickly as possible and from the time you contact us
              about repairing your truck, we're working to get your truck
              repaired and returned to service. How can we help get your box
              truck back on the road faster than anyone else? We start when you
              contact us and have your first communication with us. We get as
              many facts from you about your box truck and the damage that you
              need fixed. If it's a new roof, we're ready with the repair
              supplies and new parts right away. If something needs to be
              ordered, we can call our parts and supplies distributers have
              everything fast. We're able to repair your box truck, whether it's
              mechanical or body damage.
            </p>

            <div className="bg-[#B1050B] text-white rounded-lg p-6 text-center" data-id="element-4241">
              <p className="text-2xl font-bold" data-id="element-4242">
                Call us today for a free Estimate
              </p>
              <a href="tel:2484788382" className="text-3xl font-bold hover:text-gray-200 transition-colors" data-id="element-4243">
                248-478-8382
              </a>
            </div>
          </div>

          {/* Box Truck Corner Cap Repair */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4244">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-4245">
              <Wrench className="mr-3 text-[#B1050B]" size={32} data-id="element-4246" />
              Box Truck Corner Cap Repair
            </h2>

            <p className="text-lg text-gray-700 mb-6" data-id="element-4247">
              The corner cap can sustain damage from either impact or corrosion.
              Either one can be a problem because a damaged corner cap on a box
              truck can allow water to leak into the truck box, which puts your
              cargo at risk of water damage. Not only can that cost you big
              business due to customer dissatisfaction, it can cost you business
              because it looks unsightly and unprofessional. Our technicians are
              experts at bringing box trucks that looks worn down and worn out,
              back to a vibrant life ready to get your noticed and take care of
              your customers. If you need a new corner cap for your box truck,
              call us and let us know what you have and we'll fix your corner
              cap fast.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center" data-id="element-4248">
              <DollarSign className="mr-2 text-green-600" size={28} data-id="element-4249" />
              Box Truck Corner Cap Repair Cost
            </h3>

            <p className="text-lg text-gray-700" data-id="element-4250">
              Many people want to know how much their box truck corner cap
              repair will cost. We can tell you two things about quoting the
              cost of repair for the corner cap. First, getting it repaired
              costs far less than the potential business loss of running a box
              truck with a damaged corner cap. You know that already, so the
              second thing we can tell you about estimates for corner cap
              repairs require visual inspection. You don't want any surprises
              when having your box truck's corner cap repaired or replaced. You
              don't want your time wasted on inaccurate quotes and estimates
              that are purposefully low to hook you in and then jacked up
              hundreds or even thousands when your truck is actually on-sight
              for a damage and repair inspection. We try to give you the most
              accurate price on corn cap repairs as possible, like all our truck
              repairs.
            </p>
          </div>

          {/* CTA */}
          <div className="bg-[#B1050B] text-white rounded-lg p-6 text-center mb-8" data-id="element-4251">
            <p className="text-2xl font-bold" data-id="element-4252">
              Call us today for a free Estimate
            </p>
            <a href="tel:2484788382" className="text-3xl font-bold hover:text-gray-200 transition-colors" data-id="element-4253">
              248-478-8382
            </a>
          </div>

          {/* Box Truck Roof Repair */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4254">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-4255">
              Box Truck Roof Repair
            </h2>

            <p className="text-lg text-gray-700" data-id="element-4256">
              Your box truck roof, the roof of the actual box on your box truck,
              is as important as the walls, floor, corners, and doors. It
              protects cargo during transport as well as while it's parked and
              loaded down. You just cannot have your box truck roof leaking
              water into the inside of the box. Water damage is a leading cause
              of losses when a box truck box is in disrepair, like when there's
              a hole in the roof or an opening due to a poor seal. Not only can
              it damage cargo, it can damage the walls and floors of the cargo
              area of your box truck. The good news is, we can repair the roof
              of your box truck, regardless of the material or style of roof.
            </p>
          </div>

          {/* Box Truck Side Panel Repair */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4257">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-4258">
              Box Truck Side Panel Repair
            </h2>

            <p className="text-lg text-gray-700 mb-6" data-id="element-4259">
              Does your box truck box need new walls? Box trucks are constructed
              in a variety of ways, depending on the type and manufacturer. Most
              walls use side panels, which we can replace or if possible they
              may be able to be repaired. We'll need to inspect your box truck
              side panels to know what it'll take. Bring your box truck to us
              for an inspection and accurate estimate for repair. The cost can
              vary by manufacturer, style/type and size of the repair. Bring
              your box truck in to get the most accurate estimate of the cost of
              box truck side panels.
            </p>

            <p className="text-gray-700 mb-6" data-id="element-4260">
              Popular searches for box truck repair include "Box Truck Roof
              Repair Near Me". We're "near me", if you are located in South East
              Michigan, Northern Ohio, or Northern Indiana. Other search phrases
              that apply are "Box truck roof repair near me", "Roll Up Truck
              Door Repair Near Me" and "Box truck Side Panel Repair Near Me".
            </p>
          </div>

          {/* CTA */}
          <div className="bg-[#B1050B] text-white rounded-lg p-6 text-center mb-8" data-id="element-4261">
            <p className="text-2xl font-bold" data-id="element-4262">
              Call us today for a free Estimate
            </p>
            <a href="tel:2484788382" className="text-3xl font-bold hover:text-gray-200 transition-colors" data-id="element-4263">
              248-478-8382
            </a>
          </div>

          {/* Box Truck Body Repair */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4264">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-4265">
              Box Truck Body Repair
            </h2>

            <p className="text-lg text-gray-700 mb-6" data-id="element-4266">
              We repair box trucks, including body repairs. Sometimes the box
              itself is referred to by customers as a box truck body and
              sometimes customers are referring to the cab body. In either case,
              we'll ask for details about the repair, such as location of the
              damage to help us determine whether the box truck body repair is a
              fender, hood, rocker panel, etc or if it's actually the box where
              cargo is secured for delivery. The cost of body repair on your box
              truck can easily be determined with a visual inspection at our
              truck repair facility in Farmington Hills, MI. If you're looking
              for the best "box truck body repair near me", we think we're the
              best and we think after you've worked with us, you will agree.
              We're worth bring your box truck to for an estimate. Don't waste
              your time and cause yourself severe aggravation by having
              inexperienced box truck repair and body repair facilities work on
              your truck. Bring your truck in today.
            </p>

            <div className="grid md:grid-cols-2 gap-4" data-id="element-4267">
              <div className="bg-blue-50 rounded-lg p-4" data-id="element-4268">
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-4269">
                  Roll Up Truck Door Repair Near Me
                </h3>
                <p className="text-gray-700" data-id="element-4270">
                  Expert roll-up door repair and replacement services
                </p>
              </div>

              <div className="bg-green-50 rounded-lg p-4" data-id="element-4271">
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-4272">
                  Box Truck Parts and Accessories
                </h3>
                <p className="text-gray-700" data-id="element-4273">
                  Complete parts and accessories for all box truck needs
                </p>
              </div>
            </div>
          </div>

          {/* Truck Bodies & Accessories */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4274">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-4275">
              Truck Bodies, Parts & Accessories
            </h2>

            <div className="grid md:grid-cols-2 gap-3" data-id="element-4276">
              <div className="flex items-start" data-id="element-4277">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-4278" />
                <span className="text-gray-700" data-id="element-4279">Dump Truck Bodies</span>
              </div>
              <div className="flex items-start" data-id="element-4280">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-4281" />
                <span className="text-gray-700" data-id="element-4282">Utility Truck Bodies</span>
              </div>
              <div className="flex items-start" data-id="element-4283">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-4284" />
                <span className="text-gray-700" data-id="element-4285">Stake Truck Bodies</span>
              </div>
              <div className="flex items-start" data-id="element-4286">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-4287" />
                <span className="text-gray-700" data-id="element-4288">Snow Plows</span>
              </div>
              <div className="flex items-start" data-id="element-4289">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-4290" />
                <span className="text-gray-700" data-id="element-4291">Oak or Steel Flatbeds</span>
              </div>
              <div className="flex items-start" data-id="element-4292">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-4293" />
                <span className="text-gray-700" data-id="element-4294">Conversion Hoists</span>
              </div>
              <div className="flex items-start" data-id="element-4295">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-4296" />
                <span className="text-gray-700" data-id="element-4297">Hi Cubes</span>
              </div>
              <div className="flex items-start" data-id="element-4298">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-4299" />
                <span className="text-gray-700" data-id="element-4300">Tool Boxes</span>
              </div>
              <div className="flex items-start" data-id="element-4301">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-4302" />
                <span className="text-gray-700" data-id="element-4303">Lift Gates</span>
              </div>
              <div className="flex items-start" data-id="element-4304">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-4305" />
                <span className="text-gray-700" data-id="element-4306">Slider Ramps</span>
              </div>
              <div className="flex items-start" data-id="element-4307">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-4308" />
                <span className="text-gray-700" data-id="element-4309">Commercial Tops</span>
              </div>
              <div className="flex items-start" data-id="element-4310">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-4311" />
                <span className="text-gray-700" data-id="element-4312">Air Axles</span>
              </div>
              <div className="flex items-start" data-id="element-4313">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-4314" />
                <span className="text-gray-700" data-id="element-4315">Hydraulic Suspensions</span>
              </div>
              <div className="flex items-start" data-id="element-4316">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-4317" />
                <span className="text-gray-700" data-id="element-4318">
                  Truck Accessories, Parts & Service
                </span>
              </div>
              <div className="flex items-start" data-id="element-4319">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-4320" />
                <span className="text-gray-700" data-id="element-4321">
                  Van Bodies: Aluminum and FRP
                </span>
              </div>
            </div>
          </div>

          {/* Final CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-4322">
            <h2 className="text-3xl font-bold mb-4" data-id="element-4323">
              Expert Box Truck Repair Services
            </h2>
            <p className="text-xl mb-6" data-id="element-4324">
              #1 Choice in the Tri-State Area for Box Truck Repairs
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-4325">
              <Phone className="mr-3" size={24} data-id="element-4326" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-4327">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
            <p className="mt-2 text-gray-400" data-id="element-4328">
              Serving South East Michigan, Northern Ohio, and Northern Indiana
            </p>
          </div>
        </div>
      </div>
    </div>;
}